import { Dialog, type DialogProps, Stack } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import TeamsSelectTable, { type TeamsSelectTableProps } from "./TeamsSelectTable";

interface TeamsSelectDialogProps extends TeamsSelectTableProps {
  open: boolean;
  onClose: DialogProps["onClose"];
  containerProps?: DialogProps["PaperProps"];
}

const TeamsSelectDialog: React.FC<TeamsSelectDialogProps> = (props) => {
  const { open, onClose, containerProps, ...restProps } = props;

  return (
    <Dialog
      PaperProps={{
        sx: {
          height: !isMobile ? "80vh" : undefined,
          minHeight: !isMobile ? "70vh" : undefined,
          maxWidth: isMobile ? "85vw" : "75vw",
          maxHeight: "80vh",
          overflow: "hidden",
          ...containerProps?.sx,
        },
        ...containerProps,
      }}
      open={open}
      onClose={onClose}
    >
      <Stack
        width="100%"
        height="100%"
        minHeight={0}
        overflow="hidden"
        boxSizing="border-box"
        padding={3}
      >
        <TeamsSelectTable {...restProps} />
      </Stack>
    </Dialog>
  );
};

export default TeamsSelectDialog;
